import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";

type RedeemConfirmationModalProps = {
  open: boolean;
  onClose: () => void;
  onSend: () => void;
  isLoading?: boolean;
  name?: string;
};

export const RedeemConfirmationModal = ({
  open,
  onClose,
  onSend,
  isLoading,
  name,
}: RedeemConfirmationModalProps) => {
  return (
    <Modal.Root open={open} onOpenChange={onClose}>
      <Modal.Content size="small">
        <Modal.Header>
          <Modal.Title>Redeem perk</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-text-body-sm">
            Are you sure you want to redeem this <span>{name}</span> perk. This
            will automatically fire an intro mail for you.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="t-flex t-w-full t-justify-end t-gap-3 t-items-center">
            <Button customType="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button isLoading={isLoading} customType="primary" onClick={onSend}>
              Send
            </Button>
          </div>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
